module.exports = __webpack_public_path__ + "static/media/banner-ganaloco-mobile.e5665afb.jpg";